<div class="locationContainer">
  <form name="locationForm" novalidate>
    <div class="loader" *ngIf="step.isLoading"></div>
    <div class="group">
      <p class="label">Location *</p>
      <input
        autocomplete="off"
        type="text"
        placeholder="Enter address, country, state or select a location from the map"
        matInput
        [matAutocomplete]="auto"
        name="locationInput"
        #locationInput="ngModel"
        [(ngModel)]="searchText"
        (ngModelChange)="setLocationFromSelection()"
        required
      />

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="getPlaceName">
        <mat-option *ngFor="let option of filteredCoordinationPoints" [value]="option">
          {{option.place_name}}
        </mat-option>
      </mat-autocomplete>
      <div
        class="error"
        *ngIf="locationInput.invalid && (locationInput.dirty || locationInput.touched)"
      >
        <mat-error *ngIf="locationInput.errors.required">Location is required.</mat-error>
      </div>
    </div>
    <div id="wizard-step-map" #mapLocation></div>

    <div class="group" *ngIf="parent !== 'sites'">
      <p class="label">Name your location</p>
      <input
        autocomplete="off"
        class="alias"
        name="friendlyName"
        placeholder="Assign a friendly name to your location"
      />
    </div>
  </form>
</div>
